const Url = "https://api-surat.alhasanah.sch.id"
// const Url = "http://localhost:3000"

export default Url
